import { createContext } from "react";

import { IGatewaysContext } from "./GatewaysContext.inteface";

export const GatewaysContext = createContext<IGatewaysContext>(
  {} as IGatewaysContext
);
